export class EventPhotoAdd {
	public photo: any;
	// public form: any;

	public status;
	public errorMessage;
	public queueNumber;
	// public signedUploadUrlNumber;
}